export default __webpack_public_path__ + "static/media/power.9e6aa72a.svg";